module.exports = __webpack_public_path__ + "media/Homepage_desktop.cb5c7352.webm";